import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=a26f315c&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26f315c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a26f315c')) {
      api.createRecord('a26f315c', component.options)
    } else {
      api.reload('a26f315c', component.options)
    }
    module.hot.accept("./Paginator.vue?vue&type=template&id=a26f315c&scoped=true", function () {
      api.rerender('a26f315c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Paginator.vue"
export default component.exports